var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9323 25.9141L16.3386 4.11719C16.1509 3.79326 15.827 3.63281 15.5 3.63281C15.1731 3.63281 14.8461 3.79326 14.6615 4.11719L2.06771 25.9141C1.69535 26.5619 2.16156 27.3672 2.90628 27.3672H28.0938C28.8385 27.3672 29.3047 26.5619 28.9323 25.9141ZM5.21312 25.0694L15.5 7.2626L25.7869 25.0694H5.21312Z",
    fill: "#FFB41F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5275 12.7772C16.8 13.0497 16.9531 13.4193 16.9531 13.8047C16.9531 14.1901 16.8 14.5597 16.5275 14.8322C16.255 15.1047 15.8854 15.2578 15.5 15.2578C15.1146 15.2578 14.745 15.1047 14.4725 14.8322C14.2 14.5597 14.0469 14.1901 14.0469 13.8047C14.0469 13.4193 14.2 13.0497 14.4725 12.7772C14.745 12.5047 15.1146 12.3516 15.5 12.3516C15.8854 12.3516 16.255 12.5047 16.5275 12.7772Z",
    fill: "#FFB41F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4688 17.4375L16.4688 23.0078C16.4688 23.141 16.3598 23.25 16.2266 23.25L14.7734 23.25C14.6402 23.25 14.5313 23.141 14.5313 23.0078L14.5313 17.4375C14.5313 17.3043 14.6402 17.1953 14.7734 17.1953L16.2266 17.1953C16.3598 17.1953 16.4688 17.3043 16.4688 17.4375Z",
    fill: "#FFB41F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.7dc29727fcc2f3948e5bd601a2ef2fa5.svg";
export { ForwardRef as ReactComponent };